import styled from 'styled-components';

export const SubSubTitle = styled.h3`
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.5px;
`;
